import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/userSetup/eTRACKUserMCNMapping/initialState.eTrackUserMcnMapping.data';

const ETrackUserMCNMappingSlice = createSlice({
  name: 'ETrackUserMCNMapping',
  initialState,
  reducers: {
    setResponse: (state, action) => {
      state.saveResponse = action?.payload;
    },
    resetAdmin: (state) => {
      state.reset = initialState;
    },
    resetValues: (state) => {
      state.searchResult = initialState.searchResult;
    },
    setSearchResult: (state, action) => {
      state.searchResult = action?.payload;
    },
    UpdateUserList: (state, action) => {
      const type = action?.payload?.type;
      const user =
        type === 'delete'
          ? action?.payload?.deleteUserPayload
          : action?.payload;
      if (type === 'add') {
        state.userMCNList.push(user);
      } else if (type === 'delete') {
        state.userMCNList = state.userMCNList.filter((u) => u.id !== user.id);
      } else if (type === 'email') {
        state.userMCNList = action?.payload?.cleanedData;
      } else {
        state.userMCNList = action?.payload?.cleanedData;
      }
    },
    displayUserMCNMapping: (state, action) => {
      state.userMCNmapping = action?.payload;
    },
    setSelectedEtrackUser: (state, action) => {
      state.selectedEtrackUser = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder;
  },
});

export const {
  resetValues,
  setSearchResult,
  UpdateUserList,
  setSelectedEtrackUser,
  displayUserMCNMapping,
} = ETrackUserMCNMappingSlice.actions;
export default ETrackUserMCNMappingSlice.reducer;
